angular.module('vehicle')
    .component('vehiclePicker', {
        require: {
            ngModelCtrl: 'ngModel'
        },
        bindings: {
            required: "<",
            modelType: '<',
            onChange: "&",
            showLocation: "<"
        },
        templateUrl: "app/vehicle/picker.html",
        controller: function (Vehicle) {
            const ctrl = this;

            ctrl.$onInit = () => {
                ctrl.modelType = ctrl.modelType || "object";

                Vehicle.query().$promise.then(items => {
                    return ctrl.items = items.map(it => ({
                        ...it,
                        locationName: it.bookingSettings?.location?.name || '---'
                    }));
                });

                ctrl.ngModelCtrl.$render = () => ctrl.selected = ctrl.ngModelCtrl.$viewValue;
                ctrl.ngModelCtrl.$formatters.push(modelValue => modelValue);
                ctrl.ngModelCtrl.$parsers.push(viewValue => ctrl.modelType === "id" ? viewValue.id : viewValue);
            };

            ctrl.joinStrings = (stringsArray, delimiter) => {
                stringsArray = stringsArray || [];
                const stringsFiltered = stringsArray
                    .filter(it => it != null)
                    .filter(it => it.length > 0);
                return stringsFiltered.join(delimiter);
            };

            ctrl.onSelectionChanged = ($item, $model) => {
                ctrl.ngModelCtrl.$setViewValue($item);
                ctrl.ngModelCtrl.$validate();
                ctrl.ngModelCtrl.$render();
                if (angular.isFunction(ctrl.onChange())) {
                    ctrl.onChange()($item);
                }
            };
        }
    })
